import React, { useState } from "react";
import {
  Dialog,
  DialogSurface,
  DialogActions,
  DialogBody,
  Button,
  Text,
  Textarea,
  DialogTitle,
  DialogContent,
  makeStyles,
} from "@fluentui/react-components";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  inputArea: {
    width: "100%",
    height: "50vh",
    boxSizing: "border-box",
    marginTop: "10px",
  },
});

const TextDialog = ({ isOpen, onClose, onSubmit, title, text, label, closeText, submitText }) => {
  const [textValue, setTextValue] = useState("");

  const handleTextChange = (event, newValue) => {
    setTextValue(newValue.value || "");
  };

  const handleSubmit = () => {
    onSubmit(textValue);
    onClose();
  };

  const styles = useStyles();

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(event, data) => {
        if (!data.open) onClose();
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <Text>{text}</Text>
            <Textarea
              placeholder={label}
              multiline
              rows={3}
              value={textValue}
              onChange={handleTextChange}
              className={styles.inputArea}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSubmit}>{submitText}</Button>
            <Button onClick={onClose}>{closeText}</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
TextDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  closeText: PropTypes.string.isRequired,
  submitText: PropTypes.string.isRequired,
};
export default TextDialog;
